import styled from 'styled-components';

export const Container = styled.div`
  display: ${props => (props.active ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  background-color: #fff;
  color: #333;
  padding: 1rem;
  height: 30rem;
  width: 50rem;
  max-width: 90%;
  border-radius: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  button {
    padding: 1rem 2rem 1rem 2rem;
    margin-top: 1rem;
    background-color: var(--color-primary);
    color: #fff;
    font-weight: 500;
    border-radius: 0.5rem;
  }
`;

export const Description = styled.div`
  padding: 2rem;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    font-size: var(--font-description-size);
  }

  img {
    height: 12rem !important;
    width: 12rem !important;
  }
`;
